import { render, staticRenderFns } from "./NuevaPersona.vue?vue&type=template&id=15aec209&"
import script from "./NuevaPersona.vue?vue&type=script&lang=js&"
export * from "./NuevaPersona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports